import React from 'react';
import { Link } from '@planne-software/uni';
import { ModalHeader } from '@planne-software/uni/Modal';

import { useTranslate } from '@src/core/hooks';

import { authLinkSx } from '../../styles';
import { Modal, ZipCodeHelpBody, ZipCodeHelpContent, ZipCodeHelpText } from '../styles';

const CORREIOS_ZIP_CODE_LOOKUP = 'https://buscacepinter.correios.com.br/app/endereco/index.php';

type ZipCodeHelpModalProps = {
  open: boolean;
  onClose: () => void;
};

export const ZipCodeHelpModal = (props: ZipCodeHelpModalProps) => {
  const { open, onClose } = props;
  const { i18n } = useTranslate();

  return (
    <Modal open={open} onClose={onClose}>
      <ZipCodeHelpContent data-testid='signup-zip-code-help-modal'>
        <ModalHeader
          title={i18n('checkout_auth_signup_zip_code_help_title')}
          description={i18n('checkout_auth_signup_zip_code_help_intro')}
          divider
          align='left'
          onClose={onClose}
        />

        <ZipCodeHelpBody>
          <ZipCodeHelpText>
            {i18n('checkout_auth_signup_zip_code_help_tip_before')}{' '}
            <Link href={CORREIOS_ZIP_CODE_LOOKUP} target='_blank' rel='noreferrer' underline='always' sx={authLinkSx}>
              {i18n('checkout_auth_signup_zip_code_help_link')}
            </Link>
            {i18n('checkout_auth_signup_zip_code_help_tip_after')}
          </ZipCodeHelpText>
        </ZipCodeHelpBody>
      </ZipCodeHelpContent>
    </Modal>
  );
};

export default ZipCodeHelpModal;
